import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaLightbulb, FaGlobe, FaDatabase, FaMobile, FaLayerGroup, FaCode, FaChartLine } from 'react-icons/fa';

const ServicesContainer = styled.div`
  padding: 4rem 2rem;
  width: 100%;
  background: #fff;

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

const Title = styled(motion.h2)`
  font-size: 2rem;
  font-family: 'Playfair Display', serif;
  color: #333;
  margin-bottom: 1.5rem;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  padding: 0 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0;
  }
`;

const ServiceCard = styled(motion.div)`
  background: #fff;
  padding: 2rem 1.5rem;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 25px rgba(13, 71, 161, 0.3);
  }
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  background: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
  }

  svg {
    font-size: 2rem;
    color: white;

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 1rem;
  font-family: 'Playfair Display', serif;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }
`;

const ServiceDescription = styled.p`
  color: #666;
  line-height: 1.6;
  font-size: 0.9rem;

  @media (max-width: 768px) {
    font-size: 0.85rem;
    line-height: 1.5;
  }
`;

const Services = () => {
  const services = [
    {
      icon: <FaCode />,
      title: "Frontend Development",
      description: "Creating responsive and interactive web applications using React, JavaScript, and modern web technologies",
      color: "#2196F3"
    },
    {
      icon: <FaDatabase />,
      title: "Data Analysis",
      description: "Analyzing and processing data using Python, SQL, and data visualization tools",
      color: "#F44336"
    },
    {
      icon: <FaMobile />,
      title: "Responsive Design",
      description: "Building mobile-first, responsive websites that work seamlessly across all devices",
      color: "#FFC107"
    },
    {
      icon: <FaLayerGroup />,
      title: "Graphic Design",
      description: "Creating visually appealing designs and graphics that communicate your message effectively",
      color: "#9C27B0"
    },
    {
      icon: <FaChartLine />,
      title: "Data Visualization",
      description: "Creating interactive and informative data visualizations using modern tools and libraries",
      color: "#009688"
    },
    {
      icon: <FaLightbulb />,
      title: "INNOVATIVE IDEAS",
      description: "Bringing creative solutions to complex problems through innovative thinking and technical expertise",
      color: "#3F51B5"
    }
  ];

  return (
    <ServicesContainer>
      <Content>
        <Header>
          <Title
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            HERE ARE SOME OF MY EXPERTISE
          </Title>
        </Header>

        <ServicesGrid>
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <IconWrapper color={service.color}>
                {service.icon}
              </IconWrapper>
              <ServiceTitle>{service.title}</ServiceTitle>
              <ServiceDescription>{service.description}</ServiceDescription>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </Content>
    </ServicesContainer>
  );
};

export default Services; 